export const MTS_INTERNET = 'MTS_INTERNET';